import React from "react";
import Select from "react-select";


const FilterSelect = ({ newPartRequests, selectedCars, setSelectedCars }) => {
  const groupedOptionsMap = new Map();

  newPartRequests.forEach((request) => {
    const makeName = request.Make.name;
    const value = request.id_car_generation;
    const label = `${request.Make.name} ${request.Generation.name}`;

    if (!groupedOptionsMap.has(makeName)) {
      groupedOptionsMap.set(makeName, []);
    }

    const currentOptions = groupedOptionsMap.get(makeName);
    if (!currentOptions.some((opt) => opt.value === value)) {
      currentOptions.push({ value, label });
    }
  });

  const carOptions = Array.from(groupedOptionsMap.entries()).map(([make, options]) => ({
    label: make,
    options,
  }));

  return (
    <div style={styles.mainContainer}>
      <div style={styles.selectComponent}>
        <Select
          options={carOptions}
          isMulti
          value={selectedCars}
          onChange={(selected) => setSelectedCars(selected || [])}
          placeholder="Filtriraj po markama i modelima"
          styles={customSelectStyles}
          menuPortalTarget={document.body}
          menuPosition="absolute"
        />
      </div>
    </div>
  );
};

export default FilterSelect;
const styles = {
  mainContainer: {
    marginBottom: "20px",
    display: "flex",
    justifyContent: "flex-end"
  },
  selectComponent: {
    maxWidth: "100%",
    overflowX: "auto"
  }
}

const customSelectStyles = {
  control: (base) => ({
    ...base,
    border: "1px solid #ccc",
    borderRadius: "10px",
    padding: "2px 4px",
    minHeight: "48px",
    boxShadow: "none",
    fontWeight: 600,
    overflowX: "auto",
    display: "flex",
    flexWrap: "nowrap",
  }),
  valueContainer: (base) => ({
    ...base,
    display: "flex",
    flexWrap: "nowrap",
    overflowX: "auto",
    scrollbarWidth: "thin",
  }),
  multiValue: (styles) => ({
    ...styles,
    backgroundColor: "#004282",
    borderRadius: "20px",
    padding: "2px 6px",
    marginRight: "4px",
    whiteSpace: "nowrap",
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    color: "#fff",
    fontWeight: 500,
    paddingRight: "6px",
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    color: "#fff",
    ":hover": {
      backgroundColor: "#003060",
      color: "#fff",
    },
  }),
  placeholder: (styles) => ({
    ...styles,
    fontWeight: 400,
    color: "#666",
    whiteSpace: "nowrap",
  }),
};
